// categoria: identifica o tipo de cor pro cliente (branco | preto | madeirado |
// cinza | kashimir | azul | verde | laca). No cálculo MDF da FORMINI, são
// agrupadas em 3 preços: branco, cor (todas as não-brancas/não-laca) e laca.

export const CORES = [
  // ── Sólidos ──────────────────────────────────────────────────────────────────
  { nome: 'Branco Textura', hex: '#F0EFED', textDark: true,  tipo: 'Sólidos',  categoria: 'branco'    },
  { nome: 'Preto Textura',  hex: '#121212', textDark: false, tipo: 'Sólidos',  categoria: 'preto'     },
  { nome: 'Cinza Lunar',    hex: '#9A9898', textDark: false, tipo: 'Sólidos',  categoria: 'cinza'     },
  { nome: 'Cinza Cronos',   hex: '#5E6B72', textDark: false, tipo: 'Sólidos',  categoria: 'cinza'     },
  { nome: 'Titânio',        hex: '#BCBAB8', textDark: true,  tipo: 'Sólidos',  categoria: 'cinza'     },
  { nome: 'Gianduia',       hex: '#9B8878', textDark: false, tipo: 'Sólidos',  categoria: 'kashimir'  },
  { nome: 'Azul Índigo',    hex: '#5B7A9B', textDark: false, tipo: 'Sólidos',  categoria: 'azul'      },
  { nome: 'Verde Relva',    hex: '#737D6A', textDark: false, tipo: 'Sólidos',  categoria: 'verde'     },

  // ── Madeiras ─────────────────────────────────────────────────────────────────
  { nome: 'Legno',          hex: '#C9A87C', textDark: true,  tipo: 'Madeiras', categoria: 'madeirado' },
  { nome: 'Nogueira Veneto',hex: '#6B4C35', textDark: false, tipo: 'Madeiras', categoria: 'madeirado' },
  { nome: 'Freijó',         hex: '#B88855', textDark: true,  tipo: 'Madeiras', categoria: 'madeirado' },

  // ── Lacas ─────────────────────────────────────────────────────────────────────
  { nome: 'Laca Branca',    hex: '#FAFAFA', textDark: true,  tipo: 'Lacas',    categoria: 'laca'      },
  { nome: 'Laca Cinza',     hex: '#A89888', textDark: true,  tipo: 'Lacas',    categoria: 'laca'      },
  { nome: 'Laca Bege',      hex: '#D4C8B4', textDark: true,  tipo: 'Lacas',    categoria: 'laca'      },
]

export const GRUPOS_CORES = {
  'Sólidos':  CORES.filter(c => c.tipo === 'Sólidos').map(c => c.nome),
  'Madeiras': CORES.filter(c => c.tipo === 'Madeiras').map(c => c.nome),
  'Lacas':    CORES.filter(c => c.tipo === 'Lacas').map(c => c.nome),
}
